import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectLastOpenedPanel } from "@/redux/slices/quickSetup/selectors";

export const useAutoScrollToPanel = () => {
  const lastOpenedPanel = useSelector(selectLastOpenedPanel);
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    if (!lastOpenedPanel || hasScrolledRef.current) {
      return;
    }

    const stepMatch = lastOpenedPanel.match(/^(\d+)-/);
    if (!stepMatch) {
      return;
    }

    const stepNumber = stepMatch[1];

    // Small delay to ensure DOM is fully rendered
    const timeoutId = setTimeout(() => {
      const targetElement = document.querySelector(`[data-panel-step="${stepNumber}"]`);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });

        // Mark that we've scrolled to prevent multiple scrolls
        hasScrolledRef.current = true;
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [lastOpenedPanel]);

  useEffect(() => {
    if (!lastOpenedPanel) {
      hasScrolledRef.current = false;
    }
  }, [lastOpenedPanel]);
};
